import { apiSlice } from 'src/features/api/api-slice';
import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse } from 'src/common/interfaces';

import { FreeRoadmapResponse, PremiumRoadmapResponse } from './roadmap.types';

export const hacktivitiesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPremiumRoadmap: builder.query<ApiResponse<PremiumRoadmapResponse>, void>({
      query: () => `roadmaps/premium`,
      providesTags: [RTKQueryTag.Roadmaps],
    }),
    getFreeRoadmap: builder.query<ApiResponse<FreeRoadmapResponse>, void>({
      query: () => `roadmaps/free`,
      providesTags: [RTKQueryTag.Roadmaps],
    }),
  }),
});

export const { useGetPremiumRoadmapQuery, useGetFreeRoadmapQuery } = hacktivitiesApiSlice;
